import React from 'react';
import {hasPageAccess,getQuery,setPageTitle,gotoUrl,resolveRouterPath, isPageEnabled, isReadOnlyChk} from 'utils/common';
import {PATH_CHANGED, HOME_TITLE,DEFAULT_LANDING_PAGE} from 'utils/constants';

const WrappedComponent = (Component, route)=>{
  return class ComponentWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.route = route;
        // reset loader count so that any component wrongly(ie show without hide or hide without show)
        // calling the SHOW_LOADER will not cause the loaderCount to be corrupted as user moves to a new component/page
        app.loaderCount=0;
        // console.error('loaderCount reset to 0 on page change')
    }
    

    render(){
      //console.log(' render currentCtxKey '+this.currentCtxKey+"sD: "+route);
      
      let path = this.props.match?this.props.match.path:location.pathname;
      let query = this.props.pageQuery?getQuery('',true):getQuery(this.props.location.search);
      app.history = this.props.history;
      app.pageInfo.query = query;
      app.pageInfo.params = {};
      this.pathChanged = false;
      if(path!=this.path){
        app.pageInfo.oldPath = app.pageUris[app.pageInfo.path]?app.pageInfo.path:'';
        app.pageInfo.path = path;
        this.path = path;
        this.currentCtxKey = app.events.generateNewCtxKey(true);
        //console.log('path changed');
        this.pathChanged = true;
      }
      let params = {};
      if(this.props.match && this.props.match.params){  
        params = {...this.props.match.params};
        app.pageInfo.params = {...this.props.match.params};
      }
      if(this.props.location){
        //params = {...params,...this.props.location};
      }
      let isReadOnly = route && route.resourceCode ? isReadOnlyChk(route.resourceCode):false;
      let userType= app.userAuth ? (app.userAuth.isAdmin?'admin':'user'):null;
      if(userType && route && 
          ( route["access"] == undefined 
            || route["access"].indexOf(userType) == -1 
            || !isPageEnabled(route.name)
            || route.resourceCode && !hasPageAccess(route.resourceCode)
          )){
        gotoUrl(resolveRouterPath(DEFAULT_LANDING_PAGE,{lang:app.selectedLocale}));            
        return <React.Fragment/>;
      }
      return(<Component {...this.props} isReadOnly={isReadOnly}  query={query} {...params}/>);
    }
    componentDidMount() {
      //console.log('router did mount');
      this.path = this.path || '';
      if(this.pathChanged){
        setPageTitle(HOME_TITLE);
        //console.log('path changed ev');
       // app.events.trigger(PATH_CHANGED,app.pageInfo.oldPath,this.path);//old & new path
      }
      if(this.route) {
        app.events.trigger(PATH_CHANGED, this.route);
      }
    }


    componentWillUnmount() {
      //console.log('router going to change(unmount)' + this.path);
      //console.log(' unmount currentCtxKey '+this.currentCtxKey);
      //setTimeout(function(){
        // //console.log('---------unsubscribeUnMoutedCTx-----')
        app.events.unsubscribeUnMoutedCTx();
      //},0);
    }

    componentDidUpdate() {
      // //console.log('router did update')
    }
  }
}

  export default WrappedComponent;